// The new look's font is fetched only once someone actually uses the new look, so the
// customer portal, agent app and Classic users never download it.
const HREF = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap';

export function ensureNewLookFont(doc = document) {
  if (doc.head.querySelector('link[data-new-look-font]')) return;
  const link = doc.createElement('link');
  link.rel = 'stylesheet';
  link.href = HREF;
  link.setAttribute('data-new-look-font', '');
  doc.head.appendChild(link);
}
